import React, { useState, useEffect, useCallback } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import * as moment from "moment";
import { Form, Formik } from "formik";
import Layout from "web/components/Layout";
import { useHistory } from "react-router-dom";
import AlertModal from "web/components/AlertModal";
import AddLocation from "web/components/AddLocation";
import Spinner from "web/components/Spinner";
import EditPurchasingLimit from "./EditPurchasingLimit";
import Edit from "web/assets/images/edit-icon-1.png";
import UploadSpecification from "web/components/UploadSpecification";
import PurchasingLimit from "./PurchasingLimit";
import UploadDummy from "web/assets/images/UploadDummy.png";
import YesNoModal from "web/components/YesNoModal";
import locationTemplateWithSampleData from "web/assets/xlsx/locationTemplateWithSampleData.xlsx";
import { fetchLanguageContentNew } from "redux/actions/language";
import LocationUsers from "./LocationUsers";
import Tooltip from "@material-ui/core/Tooltip";
import { Tooltip as ReactstrapTooltip } from "reactstrap";
import information from "web/assets/images/informationIcon.png";
import { Helmet } from "react-helmet";
import {
  getPostInitialValues,
  VALIDATION_SCHEMA,
} from "web/components/utils/manageAccountUtils";

import styles from "./manageAccounts.module.scss";
import Button from "web/components/Button";
import {
  manageAccount,
  updateSubAccount,
  resentInvitation,
  uploadExcelFile,
  locationDeactivate,
  locationActivate,
  locationDelete
} from "redux/actions/accountSetting";
import styled from "styled-components";
import AddSubAccount from "web/components/AddSubAccount";

import {
  Container,
  Wrapper,
  DetailSection,
  MaxWidthWrapper,
  Location,
  Usertable,
} from "web/pages/account/account-settings/manage-accounts/manageAccountstyled";
const ManageAccounts = () => {
  const dispatch = useDispatch();
  let history = useHistory();
  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
  let accountTypeUser = localStorage.getItem("formType");
  let brokerAccount = localStorage.getItem("brokerAccount");

  const [acitveIndex, setAcitveIndex] = useState();
  const [actionType, setActionType] = useState();
  const [yesNomodal, setYesNoModal] = useState(false);
  const yesNoToggleModal = () => setYesNoModal(!yesNomodal);
  const [yesNoModalContent, setYesNoModalContent] = useState("");

  const [displayPage, setDisplayPage] = useState("MainPage");
  const [activeUser, setActiveUser] = useState();
  const [apiResponse, setApiResponse] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [currentLocationData, setCurrentLocationData] = useState([]);
  const [currentLocationIndex, setCurrentLocationIndex] = useState(null);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("/");
  const toggleModal = () => setModal(!modal);
  let title = "";
  const initialValues = getPostInitialValues();

  const token = localStorage.getItem("token");

  const [editPurchasingModal, setEditPurchasingModal] = useState(false);
  const editPurchasingToggleModal = (id, amount) => {
    setLoadResponse({
      ...loadResponse,
      purchasingLimit: amount,
      locationId: id,
    });
    setEditPurchasingModal(!editPurchasingModal);
  };
  let fileArr = [];
  const [loadResponse, setLoadResponse] = useState({
    response: "",
    locationType: "",
    totalLocation: "NA",
    purchasingLimit: "NA",
    locationName: "",
    consumedLimit: "NA",
    subAccount: "",
    dateSet: "",
    accountType: "",
    userDetail: "",
    subAccountEmail: "",
    companyName: "",
    locationId: "",
    authId: "",
    handlePayment: "",
  });

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchMyAPI();
  }, []);

  useEffect(() => {
    if (languageContentNew?.H8_Nav_Manage_Page) setPageLanguageContents(languageContentNew.H8_Nav_Manage_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  const onChange = (data) => {
    fetchMyAPI();
  };
  const onChangeHandler = (data) => {
    fetchMyAPI();
  };

  const fetchMyAPI = async () => {
    const token = await localStorage.getItem("token");
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      const response = await dispatch(manageAccount(token));
      if (response.status === "SUCCESS") {
        if (response.payload) setApiResponse(response.payload);
        if (
          response?.payload?.length !== 0 &&
          response?.payload?.listCorporateLocations !== 0
        ) {
          setLocationData(response?.payload?.listCorporateLocations);
          if (response?.payload?.listCorporateLocations.length === 1) {
            if (!response?.payload?.listCorporateLocations[0].isActive) {
              history.push('/sign-in');
              window.location.reload(false);
              // setActionType("activate")
              // setYesNoModalContent('Account deact?')
              // yesNoToggleModal()   
            }
          } else {
            for (let i = 0; i < response?.payload?.listCorporateLocations.length; i++) {
              if (response?.payload?.listCorporateLocations[i].locationType !== "MAIN" && !response?.payload?.listCorporateLocations[i].isActive && response?.payload?.listCorporateLocations[i].authId !== localStorage.getItem('authId')) {
                history.push('/sign-in');
                window.location.reload(false);
              }
            }
          }
          if (displayPage === "UserListPage")
            setCurrentLocationData(
              response?.payload?.listCorporateLocations[currentLocationIndex]
            );
          let purchasingLimit = "NA";
          let consumedLimit = "NA";
          let subAccount = undefined;
          let subAccountEmail = "";
          let locationName;
          let dateSet;
          let locationId;
          let authId;
          let locationType = false;
          let handlePayment = false;
          if (response.payload.listCorporateLocations.length !== 0) {
            purchasingLimit =
              response.payload.listCorporateLocations[0].purchasingLimit;
            consumedLimit =
              response.payload.listCorporateLocations[0].consumedLimit;
            subAccount =
              response.payload.listCorporateLocations[0].corporateSubAccounts;
            locationName =
              response.payload.listCorporateLocations[0].locationName;
            locationId = response.payload.listCorporateLocations[0].id;
            authId = response.payload.listCorporateLocations[0].authId;
            handlePayment =
              response.payload.listCorporateLocations[0].handlePayment;
            dateSet =
              response.payload.userDetail &&
              response.payload.userDetail.customerSubscription &&
              response.payload.userDetail.customerSubscription.currentPeriodEnd;

            if (
              response.payload.listCorporateLocations[0].corporateSubAccounts
                .length !== 0
            ) {
              subAccountEmail =
                response.payload.listCorporateLocations[0]
                  .corporateSubAccounts[0].email;
              locationType =
                response.payload.listCorporateLocations[0]
                  .corporateSubAccounts[0].isAdminAccount;
            }
          }
          if (!purchasingLimit) {
            purchasingLimit = "NA";
          }
          if (!consumedLimit) {
            consumedLimit = "NA";
          }
          if (subAccount.length !== 0) {
            subAccount =
              response.payload.listCorporateLocations[0]
                .corporateSubAccounts[0];
          } else {
            subAccount = undefined;
          }

          if (response.payload.userDetail.accountType === "CORPORATE_SUBACC") {
            setDisplayPage("UserListPage");
            setActiveUser("SubAccount");
            setCurrentLocationData(response.payload.listCorporateLocations[0]);
            setCurrentLocationIndex(0);
          } else {
            setActiveUser();
          }

          setLoadResponse({
            response: response.payload,
            locationType: locationType,
            purchasingLimit: purchasingLimit,
            consumedLimit: consumedLimit,
            locationName: locationName,
            locationId: locationId,
            authId: authId,
            subAccount: subAccount,
            accountType: response.payload.userDetail.account,
            userDetail: response.payload.userDetail,
            subAccountEmail: subAccountEmail,
            handlePayment: handlePayment,
            dateSet: moment(dateSet).format("MM/DD/YYYY"),
          });
        }
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        }
      }
    }
  };

  const handleClick = (index, subIndex) => {
    let purchasingLimit = "NA";
    let consumedLimit = "NA";
    let subAccount = undefined;
    let subAccountEmail = "";
    let locationName;
    let locationId;
    let authId;
    let handlePayment = false;
    let locationType = false;

    if (loadResponse.response.listCorporateLocations.length !== 0) {
      purchasingLimit =
        loadResponse.response.listCorporateLocations[index].purchasingLimit;
      consumedLimit =
        loadResponse.response.listCorporateLocations[index].consumedLimit;
      subAccount =
        loadResponse.response.listCorporateLocations[index]
          .corporateSubAccounts[subIndex];

      if (loadResponse.response.listCorporateLocations.length !== 0) {
        locationId = loadResponse.response.listCorporateLocations[index].id;
        authId = loadResponse.response.listCorporateLocations[index].authId;
        handlePayment =
          loadResponse.response.listCorporateLocations[index].handlePayment;
        subAccountEmail =
          loadResponse.response.listCorporateLocations[index]
            .corporateSubAccounts[subIndex].email;
        locationType =
          loadResponse.response.listCorporateLocations[index]
            .corporateSubAccounts[subIndex].isAdminAccount;
      }
    }

    setLoadResponse({
      ...loadResponse,
      locationType: locationType,
      purchasingLimit: purchasingLimit,
      locationName:
        loadResponse.response.listCorporateLocations[index].locationName,
      consumedLimit: consumedLimit,
      subAccount: subAccount,
      locationId: locationId,
      handlePayment: handlePayment,
      subAccountEmail: subAccountEmail,
    });
  };


  const locationDeactivateApi = async (locationId) => {
    let data =
    {
      locationId: locationId,
    }

    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      const response = await dispatch(
        locationDeactivate(data, token)
      );
      if (response.status === "SUCCESS") {
        setActionType("success")
        setModalLink("");
        setModalContent(response?.message);
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response.message);

          setModalLink("");
          toggleModal();
        }
      }
    }
  };
  const deleteApi = async (locationId) => {
    let data =
    {
      locationId: locationId,
    }
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      const response = await dispatch(
        locationDelete(data, token)
      );
      if (response.status === "SUCCESS") {
        setActionType("success")
        setModalLink("");
        setModalContent(response?.message);
        toggleModal();
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };
  const activeApi = async (locationId) => {
    let data =
    {
      locationId: locationId,
    }
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      const response = await dispatch(
        locationActivate(data, token)
      );
      if (response.status === "SUCCESS") {
        setActionType("success")
        setModalLink("");
        setModalContent(response?.message);
        toggleModal();
        //  fetchMyAPI();
      } else {
        if (response.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.message);
          setModalLink("");
          toggleModal();
        }
      }
    }
  };
  const reinviteUser = async (data) => {
    let apiData = [
      {
        fullname: data.name,
        token: null,
        email: data.email,
      },
    ];
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      const resentInvitationResponse = await dispatch(
        resentInvitation(apiData, token)
      );
      if (resentInvitationResponse.status === "SUCCESS") {
        let indexVal = null;
        if (pageLanguageContents?.Backend_Popups) {
          pageLanguageContents.Backend_Popups.forEach((val, index) => {
            if (Object.keys(val)[0] === resentInvitationResponse.message) {
              indexVal = index;
            }
          });
        }
        if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][resentInvitationResponse.message])
        else setModalContent(resentInvitationResponse.message);

        setModalLink("");
        toggleModal();
      } else {
        if (resentInvitationResponse.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          let indexVal = null;
          if (pageLanguageContents?.Backend_Popups) {
            pageLanguageContents.Backend_Popups.forEach((val, index) => {
              if (Object.keys(val)[0] === resentInvitationResponse.message) {
                indexVal = index;
              }
            });
          }
          if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][resentInvitationResponse.message]);
          else setModalContent(resentInvitationResponse.message);

          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const clickHandler = async (locationName, subAccount, action) => {
    let data = {
      locationName: locationName,
      subAccEmail: subAccount.email,
      action: action,
    };
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      const SubAccountResponse = await dispatch(updateSubAccount(data, token));
      if (SubAccountResponse.status === "SUCCESS") {
        let indexVal = null;
        if (pageLanguageContents?.Backend_Popups) {
          pageLanguageContents.Backend_Popups.forEach((val, index) => {
            if (Object.keys(val)[0] === SubAccountResponse.message) {
              indexVal = index;
            }
          });
        }
        if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][SubAccountResponse.message]);
        else setModalContent(SubAccountResponse.message);

        setModalLink("");
        toggleModal();
        onChange();
      } else {
        if (SubAccountResponse.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          let indexVal = null;
          if (pageLanguageContents?.Backend_Popups) {
            pageLanguageContents.Backend_Popups.forEach((val, index) => {
              if (Object.keys(val)[0] === SubAccountResponse.message) {
                indexVal = index;
              }
            });
          }
          if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][SubAccountResponse.message])
          else setModalContent(SubAccountResponse.message);

          setModalLink("");
          toggleModal();
        }
      }
    }
  };
  const uploadTemplete = async () => {
    let formData = new FormData();
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink('/sign-in');
      toggleModal();
    } else {
      if (fileArr.length !== 0) {
        for (let i = 0; i < fileArr.length; i++) {
          formData.append("file", fileArr[i]);
        }

        let response = await dispatch(uploadExcelFile(formData, token));
        if (response.status === "SUCCESS") {
          let indexVal = null;
          if (pageLanguageContents?.Backend_Popups) {
            pageLanguageContents.Backend_Popups.forEach((val, index) => {
              if (Object.keys(val)[0] === response.message) {
                indexVal = index;
              }
            });
          }
          if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.message])
          else setModalContent(response.message);

          setModalLink("");
          toggleModal();
          fetchMyAPI();
        } else {
          if (response.message || response.statusCode) {
            if (response.statusCode === 401) {
              history.push('/sign-in');
              window.location.reload(false);
            } else {
              let indexVal = null;
              if (pageLanguageContents?.Backend_Popups) {
                pageLanguageContents.Backend_Popups.forEach((val, index) => {
                  if (Object.keys(val)[0] === response.message) {
                    indexVal = index;
                  }
                });
              }
              if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.message])
              else setModalContent(response.message);
            }
          } else if (response.error !== undefined && response.error.length > 0)
            setModalContent(
              `${response.message}, ${response.error[0].message}`
            );
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const uploadLocationTemplate = () => {
    return (
      <Formik
        validateOnMount
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={VALIDATION_SCHEMA()}
        onSubmit={(values) => { }}
      >
        {(props) => {
          const { values, setFieldValue, isValid, dirty } = props;
          return (
            <Form className="form">
              <ManageStepUpload>
                <UploadSpecification
                  name="taxExemption"
                  props={props}
                  pageLanguageContents={pageLanguageContents}
                  ProfileName=""
                  CompanyName=""
                  pageType=""
                  fileArr={fileArr}
                  acceptFiles={
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  }
                  callBackFun={(imageArr) => {
                    uploadTemplete();
                  }}
                />
              </ManageStepUpload>
            </Form>
          );
        }}
      </Formik>
    );
  };

  const [tooltipTitle, setTooltipTitle] = useState(false);
  const iIconTitle = (infoTxt) => {
    return (
      <>
        <img
          id="TooltipPreference"
          src={information}
          style={{
            paddingLeft: "5px",
            position: "relative",
            top: "-1px",
          }}
        />
        <ReactstrapTooltip
          placement="right"
          isOpen={tooltipTitle}
          target="TooltipPreference"
          toggle={() => setTooltipTitle(!tooltipTitle)}
        >
          {infoTxt}
        </ReactstrapTooltip>
      </>
    );
  };
  const accountType = localStorage.getItem("accountType");
  let selectedSearch;
  if (accountType === "Seller") {
    selectedSearch = "PostLoad";
  }
  if (accountType === "Buyer") {
    selectedSearch = "PostInventory";
  }

  return (
    <>
      <Helmet title="Manage Users and Locations &  Your Profile Information | PalletTrader" >
        <meta name="description"
          content="Manage your marketplace account information. Create your profile, settings, and preferences for a personalized and seamless buying and selling experience." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/manage-users-and-locations" />
      </Helmet>
      <Layout selectedSearch={selectedSearch} topBarViewMobile={"hide"} pageType={'ManageLocations'}>
        {loaderVisible && <Spinner />}
        <Container>
          <MaxWidthWrapper>
            <div></div>
            {displayPage === "MainPage" ? (
              <Wrapper>
                {accountTypeUser !== "CORPORATE_SUBACC" && (
                  <>
                    <div className="manage-location-header">
                      <h4 style={{ marginBottom: "0" }}>
                        {brokerAccount === "brokerAc"
                          ? pageLanguageContents?.Location_Contents[27]?.Title_Broker
                          : pageLanguageContents?.Location_Contents[0]?.Title}
                      </h4>

                      <div className="web-view">
                        {brokerAccount === "brokerAc" ? (
                          <p style={{ textAlign: "justify", color: "#0a5587" }}>
                            {pageLanguageContents?.Location_Contents[28]?.Title_Broker_Description}
                          </p>
                        ) : (
                          <p style={{ textAlign: "justify", color: "#0a5587" }}>
                            {pageLanguageContents?.Location_Contents[29]?.Title_Description}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mobile-view box-shadow">
                      {brokerAccount === "brokerAc" ? (
                        <p style={{ textAlign: "justify", color: "#0a5587" }}>
                          {pageLanguageContents?.Location_Contents[28]?.Title_Broker_Description}
                        </p>
                      ) : (
                        <p style={{ textAlign: "justify", color: "#0a5587" }}>
                          {pageLanguageContents?.Location_Contents[29]?.Title_Description}
                        </p>
                      )}
                    </div>
                    <DetailSection>
                      {apiResponse.userDetail &&
                        apiResponse.userDetail.name &&
                        apiResponse.userDetail.account && (
                          <>
                            {apiResponse.userDetail.registerDTO &&
                              apiResponse.userDetail.registerDTO.basicDetail && (
                                <div className="company-detail">
                                  <h3>
                                    {
                                      apiResponse.userDetail.registerDTO
                                        .basicDetail.companyName
                                    }
                                  </h3>
                                  <h4>{`${apiResponse.userDetail.registerDTO.basicDetail.registeredAddress.line1}`}</h4>
                                  <h4>{`${apiResponse.userDetail.registerDTO.basicDetail.registeredAddress.city} ${apiResponse.userDetail.registerDTO.basicDetail.registeredAddress.state} ${apiResponse.userDetail.registerDTO.basicDetail.registeredAddress.zip}`}</h4>
                                </div>
                              )}
                          </>
                        )}
                    </DetailSection>
                  </>
                )}
                {accountTypeUser !== "CORPORATE_SUBACC" && (
                  <>
                    <Location>
                      <div className="add-location">
                        <div>
                          {loadResponse.response !== "" && (
                            <AddLocation
                              buttonName={pageLanguageContents?.Location_Sidebar[2]?.Button2}
                              loadResponse={loadResponse}
                              onChange={onChange}
                              pageLanguageContents={pageLanguageContents}
                            />
                          )}

                        </div>
                        {brokerAccount !== "brokerAc" && (
                          <div className="action-btn"></div>
                        )}
                      </div>
                    </Location>
                    <Usertable>
                      <div className="table-header">
                        <p>
                          {brokerAccount === "brokerAc" ||
                            (apiResponse &&
                              apiResponse.userDetail &&
                              apiResponse.userDetail.account === "INDIVIDUAL")
                            ? pageLanguageContents?.Location_Contents[32]?.UsersHeading
                            : pageLanguageContents?.Location_Contents[31]?.LocationsHeading}
                        </p>
                      </div>
                      <div className="table-body">
                        {locationData &&
                          locationData.map((data, index) => {
                            return (
                              <div className="table-row" key={index}>
                                <div>
                                  <Tooltip
                                    placement="top"
                                    arrow
                                    title={data.locationName}
                                    enterTouchDelay={5}
                                    leaveTouchDelay={10000}
                                  >
                                    <span
                                      onClick={() => {
                                        if (data.corporateSubAccounts.length > 0) {
                                          setCurrentLocationData(data);
                                          setDisplayPage("UserListPage");
                                          setCurrentLocationIndex(index);
                                        }
                                      }}>
                                      {data.locationName} - {data.address.city}
                                      &nbsp;{data.address.state}
                                    </span>
                                  </Tooltip>
                                  <span>{data.corporateSubAccounts.length}</span>
                                  {data.handlePayment &&
                                    data.locationType === "SUBSIDIARY" && (
                                      <span>
                                        I
                                        <Tooltip
                                          placement="top"
                                          arrow
                                          title={
                                            "I is an independent account where the location is responsible for payment independently."
                                          }
                                          enterTouchDelay={5}
                                          leaveTouchDelay={10000}
                                        >
                                          <img
                                            id={"TooltipIndependent" + index}
                                            src={information}
                                            style={{
                                              paddingLeft: "5px",
                                              position: "relative",
                                              top: "-1px",
                                            }}
                                          />
                                        </Tooltip>
                                      </span>
                                    )}
                                  {data.locationType === "MAIN" &&
                                    <span></span>}

                                  {!data.handlePayment &&
                                    data.locationType === "SUBSIDIARY" && (
                                      <span>
                                        D
                                        <Tooltip
                                          placement="top"
                                          arrow
                                          title={
                                            "D is a dependent account where this master account’s payment method will be used for payment."
                                          }
                                          enterTouchDelay={5}
                                          leaveTouchDelay={10000}
                                        >
                                          <img
                                            id={"Dependent" + index}
                                            src={information}
                                            style={{
                                              paddingLeft: "5px",
                                              position: "relative",
                                              top: "-1px",
                                            }}
                                          />
                                        </Tooltip>
                                      </span>
                                    )}

                                  <span>
                                    {data.purchasingLimit ? (
                                      <>
                                        {apiResponse.totalUsage /
                                          data.purchasingLimit}
                                        %
                                      </>
                                    ) : (
                                      <>0%</>
                                    )}
                                    <Tooltip
                                      placement="top"
                                      arrow
                                      title={
                                        "Monthly Spend % = Total Monthly Spend / Monthly Purchasing Limit."
                                      }
                                      enterTouchDelay={5}
                                      leaveTouchDelay={10000}
                                    >
                                      <img
                                        id={"Spend" + index}
                                        src={information}
                                        style={{
                                          paddingLeft: "5px",
                                          position: "relative",
                                          top: "-1px",
                                        }}
                                      />
                                    </Tooltip>
                                  </span>
                                </div>
                                {(accountTypeUser === "INDIVIDUAL" ||
                                  apiResponse.userDetail.accountType ===
                                  "CORPORATE_ADMIN") && (
                                    <>
                                      {locationData[index].isActive ?
                                        <div className="add-user-btn addUser">
                                          <AddSubAccount
                                            pageLanguageContents={pageLanguageContents}
                                            buttonName="Add User"
                                            locationList={locationData}
                                            index={index}
                                            onChangeHandler={onChangeHandler}
                                          />
                                        </div> :
                                        <div style={{ minWidth: '82px' }}></div>
                                      }

                                      {/* ----------dont delete---------- */}
                                      {/* {!locationData[index].isActive && locationData[index].locationType === "SUBSIDIARY" && <span className="activeUser">
                                        <Button
                                          type="app-green-button"
                                          handleClick={() => {
                                            setAcitveIndex(index)
                                            setActionType("activate")
                                            setYesNoModalContent('Do you want to activate the location?')
                                            yesNoToggleModal()
                                            //  activeApi(locationData[index].id)
                                          }}
                                        >
                                          Activate
                                        </Button></span>}

                                      {locationData[index].locationType === "SUBSIDIARY" && locationData[index].isActive && !locationData[index].deleteLocation &&
                                        <Button
                                          type="app-green-button"
                                          handleClick={() => {
                                            setAcitveIndex(index)
                                            setActionType("deactivate")
                                            setYesNoModalContent('Do you want to deactivate the location?')
                                            yesNoToggleModal()
                                            // locationDeactivateApi(locationData[index].id)
                                          }}
                                        >
                                          Deactivate
                                        </Button>} */}

                                      {locationData[index].locationType === "SUBSIDIARY" && locationData[index].deleteLocation ?
                                        <Button
                                          type="app-green-button"
                                          handleClick={() => {
                                            setAcitveIndex(index)
                                            setActionType("delete")
                                            setYesNoModalContent('Do you want to delete the location?')
                                            yesNoToggleModal()
                                            // deleteApi(locationData[index].id)
                                          }}
                                        >
                                          Delete
                                        </Button> : <div style={{ width: '133px' }}></div>}
                                    </>
                                  )}
                              </div>
                            );
                          })}
                      </div>
                    </Usertable>
                  </>
                )}
              </Wrapper>
            ) : (
              <LocationUsers
                toggleDisplayPage={() => setDisplayPage("MainPage")}
                currentLocationData={currentLocationData}
                currentLocationIndex={currentLocationIndex}
                pageLanguageContents={pageLanguageContents}
                locationData={locationData}
                activeUser={activeUser}
                apiResponse={apiResponse}
                onChangeHandler={onChangeHandler}
                description={pageLanguageContents?.Location_Contents[29]?.Title_Description}
                editPurchasingToggleModal={editPurchasingToggleModal}
                clickHandler={clickHandler}
                reinviteUser={reinviteUser}
              />
            )}
          </MaxWidthWrapper>
        </Container>
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={title}
          content={modalContent}
          link={modalLink}
          alertType={actionType}
          callBackAlert={(val) => {
            if (val === "success") {
              fetchMyAPI();
            }
          }}
        />

        <YesNoModal
          isOpen={yesNomodal}
          toggle={yesNoToggleModal}
          title={""}
          content={yesNoModalContent}
          type="inventory"
          onClickHander={(val) => {
            if (!val) {
              yesNoToggleModal();
              if (actionType === "activate") {
                activeApi(locationData[acitveIndex].id)
              }
              if (actionType === "deactivate") {
                locationDeactivateApi(locationData[acitveIndex].id)
              }
              if (actionType === "delete") {
                deleteApi(locationData[acitveIndex].id)
              }
            }

          }}
          link=""
        />

        {loadResponse && (
          <EditPurchasingLimit
            isOpen={editPurchasingModal}
            toggle={editPurchasingToggleModal}
            link=""
            responseSet={loadResponse}
            pageLanguageContents={pageLanguageContents}
            callBackFun={(index) => {
              editPurchasingToggleModal();
              fetchMyAPI();
            }}
          />
        )}
      </Layout>
    </>
  );
};

export default ManageAccounts;

const ManageStepUpload = styled.div`
  .uploadPhoto {
    flex-direction: column;
    align-items: flex-start;
  }
  .error-message-multiple {
    position: unset;
    max-width: 100% !important;
    text-align: left;
    white-space: normal !important;
  }
`;
